import { Col, Row } from 'react-bootstrap'
import { FaEye as ViewIcon } from 'react-icons/fa'

import { Date as DateGateway } from '@core/gateways'
import { RelatorioConsumoLancheItem } from '@core/types/services'
import { ActionButton, Input } from '@presentation/components/molecules'
import { Modal } from '@presentation/components/organisms'
import { useModal } from '@presentation/hooks'
import { ModalProps } from '@presentation/types/components/organisms'

import { formatCpf } from '../../utils'

type Props = {
  item: RelatorioConsumoLancheItem
}

const formatDateTime = (value: string) => {
  if (!value) return ''

  return DateGateway.format({
    date: value,
    pattern: 'dd/LL/yyyy HH:mm'
  })
}

const ViewRelatorioConsumoLancheModal: React.FC<Props> = ({ item }) => {
  const { isOpen, openModal, closeModal } = useModal()

  const modalConfigs: ModalProps = {
    isOpen,
    icon: <ViewIcon />,
    title: 'Visualização do Consumo de Lanche',
    description: 'Confira abaixo os dados do consumo selecionado.',
    size: 'lg',
    onClose: closeModal
  }

  return (
    <>
      <ActionButton type="view" onClick={openModal} />
      <Modal {...modalConfigs}>
        <Row className="mb-3">
          <Col md={8}>
            <Input label="Nome" value={item.nome ?? ''} readOnly />
          </Col>
          <Col md={4}>
            <Input label="CPF" value={formatCpf(item.cpf)} readOnly />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={4}>
            <Input label="Matrícula" value={item.matricula ?? ''} readOnly />
          </Col>
          <Col md={4}>
            <Input
              label="Tipo de lanche"
              value={item.tipo_lanche ?? ''}
              readOnly
            />
          </Col>
          <Col md={4}>
            <Input
              label="Data/Hora do consumo"
              value={formatDateTime(item.data_horario_consumo)}
              readOnly
            />
          </Col>
        </Row>
        <Row className="mb-3">
          <Col md={8}>
            <Input label="Curso" value={item.curso ?? ''} readOnly />
          </Col>
          <Col md={4}>
            <Input label="Turno" value={item.turno_curso ?? ''} readOnly />
          </Col>
        </Row>
      </Modal>
    </>
  )
}

export default ViewRelatorioConsumoLancheModal
